import { render } from "./DADataTable.vue?vue&type=template&id=3fe854f4&scoped=true"
import script from "./DADataTable.vue?vue&type=script&lang=js"
export * from "./DADataTable.vue?vue&type=script&lang=js"

import "./DADataTable.vue?vue&type=style&index=0&id=3fe854f4&lang=scss&scoped=true"

import exportComponent from "../../../../../DIARC/pixonanimation.az/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fe854f4"]])

export default __exports__